/**
 * Куда смотрит фронт: на локальный бэкенд или на боевой.
 *
 * Раньше выбор был жёстко привязан к NODE_ENV, и чтобы посмотреть локальным
 * фронтом на боевые данные, приходилось руками править адрес в helpers/api.js
 * (там до сих пор лежит след — закомментированная строка). Это регулярно
 * уезжало в коммиты и ломало сборку следующему.
 *
 * Теперь цель задаётся переменной REACT_APP_API_TARGET:
 *
 *   yarn start        — dev-фронт против локального бэкенда (как было)
 *   yarn start:prod   — dev-фронт против боевого бэкенда
 *
 * Продакшн-сборка целится в боевой всегда, независимо от переменной.
 *
 * Важно: цель — это ОДИН выбор на всё сразу, и API, и сокеты. Половинчатое
 * состояние (запросы в боевой бэк, а сокет в локальный Reverb) выглядит как
 * рабочее подключение, в котором ничего не приходит: события публикуются в
 * один Reverb, а слушаются в другом.
 */

export const IS_PROD_BUILD = process.env.NODE_ENV === 'production'

/** Целимся в боевой бэкенд. */
export const IS_PROD_TARGET = IS_PROD_BUILD || process.env.REACT_APP_API_TARGET === 'prod'

// Картинки (логотипы, баннеры, фото товаров) всегда грузятся на боевой сервер,
// в локальном storage их нет — поэтому и показываем их с боевого при любой цели
const PROD_ORIGIN = 'https://backend.mison.uz'

const PROD = {
	baseURL: `${PROD_ORIGIN}/api`,
	backendUrl: PROD_ORIGIN,
	uploadsBaseUrl: PROD_ORIGIN,
}

const LOCAL = {
	baseURL: 'http://127.0.0.1:8000/api',
	backendUrl: 'http://127.0.0.1:8000',
	uploadsBaseUrl: PROD_ORIGIN,
}

export function getApiConfig() {
	return IS_PROD_TARGET ? PROD : LOCAL
}

/**
 * Origin бэкенда для запросов мимо helpers/api (там свои axios-инстансы).
 * Раньше эти места читали REACT_APP_URL, который выбранную цель не знает.
 */
export function getBackendUrl() {
	return getApiConfig().backendUrl
}

/**
 * Куда отправлять после разлогина. Это про адрес САМОГО фронта, а не бэкенда:
 * локально запущенный фронт, смотрящий в боевой API, должен остаться на
 * localhost, а не улететь на cabinet.mison.uz.
 */
export function getLoginUrl() {
	// В dev — свой же origin: фронт может быть поднят и не на 3007 (второй экземпляр
	// против боевого API), и выкидывало бы на чужой порт с другой целью API
	return IS_PROD_BUILD
		? 'https://cabinet.mison.uz/auth/login'
		: `${window.location.origin}/auth/login`
}

/**
 * Настройки подключения к Reverb.
 *
 * Порт локального Reverb переопределяется через REACT_APP_DEV_WSPORT — на
 * случай, если он поднят не на 6001.
 */
export function getSocketConfig() {
	if (IS_PROD_TARGET) {
		return {
			wsHost: process.env.REACT_APP_PROD_WSHOST,
			authEndpoint: process.env.REACT_APP_PROD_BROADCAST_AUTH,
			wsPort: 443,
			isProd: true,
		}
	}

	return {
		wsHost: process.env.REACT_APP_DEV_WSHOST,
		authEndpoint: process.env.REACT_APP_DEV_BROADCAST_AUTH,
		wsPort: Number(process.env.REACT_APP_DEV_WSPORT) || 6001,
		isProd: false,
	}
}
